var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"h-[40px] flex items-center gap-[5px]"},[(_vm.data.isLoading)?_c('b-spinner',{attrs:{"variant":"primary","small":""}}):_c('div',[_vm._v(" "+_vm._s(_vm._f("rupiah")(_vm.data.cost))+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }